import { useEffect } from 'react';

export function useScrollToTopOnMount(options?: Omit<ScrollOptions, 'top'>) {
  // Intentionally omitting options so that the effect doesn't trigger when options change.
  useEffect(() => window.scrollTo({ top: 0, ...options }), []);
}
